module.exports = __webpack_public_path__ + "img/loading.28bc098f.svg";